import { EllipsisVertical } from "lucide-react";
import {
  SIDEBAR_WIDTH_MOBILE,
  SidebarFooter as SidebarFooterComponent,
} from "@/_old/components/ui/sidebar";
import { useSidebar } from "@/_old/components/ui/sidebar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuTrigger,
} from "@/_old/components/ui/dropdown-menu";
import {
  DropdownMenuSeparator,
  DropdownMenuLabel,
} from "@radix-ui/react-dropdown-menu";
import { UserMenu } from "./user-menu";
import { Sheet, SheetContent } from "@/_old/components/ui/sheet";
import { useState } from "react";
import SidebarUserProfile from "./sidebar-user-profile";

export function SidebarFooter() {
  const [openMobile, setOpenMobile] = useState<boolean>(false);

  const { state } = useSidebar();

  const hideText = state === "collapsed";

  return (
    <SidebarFooterComponent
      className={`border-t p-4 ${hideText ? "px-2" : ""} cursor-pointer`}
    >
      <DropdownMenu>
        <SidebarFooterTrigger onClickMobile={() => setOpenMobile(true)}>
          <div className="flex items-center justify-between">
            <SidebarUserProfile hideText={hideText} />
            {!hideText && <EllipsisVertical className="h-5 w-5 text-primary" />}
          </div>
        </SidebarFooterTrigger>

        <DropdownMenuContent
          className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
          side="right"
          align="end"
          sideOffset={4}
        >
          <DropdownMenuLabel className="p-0 font-normal">
            <div className="px-1.5 py-1">
              <SidebarUserProfile hideText={hideText} />
            </div>
          </DropdownMenuLabel>

          <DropdownMenuSeparator />

          <DropdownMenuGroup className="flex flex-col mt-2">
            <UserMenu as="dropdown" />
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>

      <Sheet open={openMobile} onOpenChange={setOpenMobile}>
        <SheetContent
          data-sidebar="sidebar"
          data-mobile="true"
          className="w-[--sidebar-width] bg-secondary p-0 text-sidebar-foreground [&>button]:hidden"
          style={
            {
              "--sidebar-width": SIDEBAR_WIDTH_MOBILE,
            } as React.CSSProperties
          }
          side={"left"}
        >
          <div className="flex h-full w-full flex-col pt-6">
            <UserMenu as="sheet" />
          </div>
        </SheetContent>
      </Sheet>
    </SidebarFooterComponent>
  );
}

function SidebarFooterTrigger({
  children,
  onClickMobile,
}: {
  children: React.ReactNode;
  onClickMobile: () => void;
}) {
  const { isMobile } = useSidebar();

  if (!isMobile) {
    return <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>;
  }

  return (
    <>
      <div onClick={onClickMobile}>{children}</div>
    </>
  );
}
